module.exports = __webpack_public_path__ + "img/mobile_t12.5865a882.png";